import { type AudioVisitation } from '@reliance/types/models/Visitation';
import { type VisitationBooth } from '@reliance/types/models/VisitationBooth';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { type ApiService } from '../types/ApiService';

export const audioVisitation = (siteApi: ApiService) => ({
  index: (params?): Promise<PaginatedResponse<AudioVisitation>> => {
    return siteApi.get('/audio-visitation', { params });
  },
  get: (id) => {
    return siteApi.get(`/audio-visitation/${id}`);
  },
  booth: {
    index: (params): Promise<VisitationBooth[]> => {
      return siteApi.get('/audio-visitation/booth', { params });
    },
  },
});
